module.exports = __webpack_public_path__ + "static/media/Logo-w-slogan.642cd593.svg";